// HomeScreen.jsx
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BlankCard, ImageTemplateCard, ContestIllustration, BrowseIllustration, TestRow, formatTimestamp, mapTests } from "./Utility/Utility";
import { useTests } from "../Context/TestContext";
import { getCurrentUserId } from "../../Backend/Auth/UserStore";
import { NewTestDialog } from "./Utility/NewTestDialog";
import MessageDialog from "../Utility/LinkBox";


const FONTS_URL = "https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap";




/* ── Main ── */
export default function HomeScreen({ setGlobalNotice }) {
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showNewTest, setShowNewTest] = useState(false);
  const [showMessage, setMessage] = useState(null);
  const navigate = useNavigate();
  const { tests, loading, loadTests, invalidate } = useTests();
  const userId = getCurrentUserId();

  useEffect(() => {
    const link = document.createElement("link");
    link.href = FONTS_URL; link.rel = "stylesheet";
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  useEffect(() => {
    invalidate();
    if (userId && !userId.startsWith('guest-')) loadTests(userId);
    console.log("tests", tests);
  }, [userId]);
  const mappedTests = mapTests(tests ?? []);

  return (
    <div style={{ minHeight: "100vh", background: "#fff", fontFamily: "'DM Sans', sans-serif" }}>
      <style>{`
        @media (max-width: 600px) {
          .template-text { display: none !important; }
          .template-image { height: 120px !important; }
          .template-card { min-width: 120px !important; flex: 0 0 120px !important; }
          .test-row-desktop-meta { display: none !important; }
          .test-row-mobile-meta { display: flex !important; }
        }
      `}</style>

      {/* ── Templates ── */}
      <section style={{ background: "#f1f3f4", borderBottom: "1px solid #e0e0e0", padding: "36px 0 40px" }}>
        <div style={{ maxWidth: "740px", margin: "0 auto", padding: "0 24px" }}>
          <p style={{ fontWeight: 500, fontSize: "14px", color: "#202124", margin: "0 0 18px 2px" }}>
            Start a new test
          </p>
          <div style={{
            display: "flex", gap: "18px", overflowX: "auto",
            paddingBottom: "4px", WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none", msOverflowStyle: "none",
          }}>
            <BlankCard onClick={() => setShowNewTest(true)} />   {/* ← opens dialog */}
            <ImageTemplateCard title="Public Contests" description="Join public quizzes and contests" bgColor="#E8F4FD" illustration={<ContestIllustration />} />
            <ImageTemplateCard title="Browse Tests" description="Search published tests by others" bgColor="#FFF8E1" illustration={<BrowseIllustration />} />
          </div>
        </div>
      </section>

      {/* ── Recent Tests ── */}
      <section style={{ maxWidth: "740px", margin: "0 auto", padding: "28px 24px 60px" }}>
        <p style={{ fontWeight: 500, fontSize: "14px", color: "#202124", margin: "0 0 8px 2px" }}>
          Recent tests
        </p>

        {loading && (
          <div style={{ textAlign: "center", padding: "40px 0", color: "#aaa", fontSize: 14 }}>
            Loading…
          </div>
        )}

        {!loading && mappedTests.length === 0 && (
          <div style={{ textAlign: "center", padding: "48px 0", color: "#bbb" }}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{ marginBottom: 12 }}>
              <rect x="8" y="6" width="32" height="38" rx="4" stroke="#ddd" strokeWidth="2" />
              <line x1="15" y1="16" x2="33" y2="16" stroke="#ddd" strokeWidth="2" strokeLinecap="round" />
              <line x1="15" y1="23" x2="33" y2="23" stroke="#ddd" strokeWidth="2" strokeLinecap="round" />
              <line x1="15" y1="30" x2="25" y2="30" stroke="#ddd" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <p style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>No tests yet</p>
            <p style={{ margin: "4px 0 0", fontSize: 12 }}>Create your first test above</p>
          </div>
        )}

        {!loading && mappedTests.length > 0 && (
          <div>
            {mappedTests.map(test => (
              <TestRow
                key={test.id}
                test={test}
                openMenuId={openMenuId}
                setOpenMenuId={setOpenMenuId}
                onShareLink={(id) => setMessage({
                  vibe: "success",
                  title: "Share this test",
                  message: `https://useocul.com/test/${id}`
                })}
                onClick={() => navigate('/analysis', {
                  state: {
                    test: test
                  }
                })} 
              />
            ))}
          </div>
        )}
      </section>

      {/* ── Dialog ── */}
      {showNewTest && (
        <NewTestDialog
          onConfirm={() => { setShowNewTest(false); navigate("/builder"); }}
          onCancel={() => setShowNewTest(false)}
          setGlobalNotice={setGlobalNotice}
        />
      )}
      {showMessage && (
        <MessageDialog
          vibe={showMessage.vibe}
          title={showMessage.title}
          message={showMessage.message}
          onClose={() => setMessage(null)}
        />
      )}
    </div>
  );
}